import _ from "lodash";

import * as k4util from "@/utils/k4util";

import Node from "./baseNode";
import * as path from "../path";

export default class SceneNode extends Node {
	static get modelName() {
		return "SceneNode";
	}

	constructor(k4node) {
		super(k4node);

		const root = k4node.root();

		// Find all actions associated with this scene
		const actions = _.filter(
			root.classes[k4util.DEVICE_CLASS_ACTION],
			action =>
				path.normalize(action.child("properties/scene").value()) === this.path
		);

		// Follow actions to their associated triggers. Drop any actions that are
		// missing a trigger path or if it's invalid.
		this.triggers = _.chain(actions)
			.map(action => action.child("properties/trigger").value())
			// Follow path to make sure it exists...
			.map(triggerPath => root.child(triggerPath))
			// Drop any nodes that don't exist
			.compact()
			// Then map again as JSON reference to node that we now know exists.
			.map(triggerNode => path.$ref(triggerNode.path()))
			.uniq()
			.compact()
			.value();
	}

	get steps() {
		const steps = _.filter(this.children, child => (child.group = "step"));

		return _.sortBy(steps, step => {
			// Default to a sort order of '1'
			const order = _.get(step, "properties.order.value", 1);
			return order;
		});
	}

	get hasTime() {
		const triggers = this.triggers || [];
		return triggers.some(trigger => trigger.hasTime);
	}

	get hasDate() {
		const triggers = this.triggers || [];
		return triggers.some(trigger => trigger.hasDate);
	}

	get hasEvent() {
		const triggers = this.triggers || [];
		return triggers.some(trigger => trigger.hasEvent);
	}

	get hasCommand() {
		const steps = this.steps || [];
		return steps.some(step => step.targetIsCommand);
	}
}
